<template>
	<c-dialog ref="dialog" width="450" @resolve="editHandle">
		<c-form ref="form" vertical unit-width="100%">
			<c-input type="hidden" name="id"></c-input>
			<c-form-item label="单位名称" required>
				<c-input name="unit" maxlength="50"></c-input>
			</c-form-item>
			<c-form-item label="备注">
				<c-input type="textarea" name="remark" maxlength="500"></c-input>
			</c-form-item>
		</c-form>
	</c-dialog>
</template>

<script>
export default {
	data() {
		return {
			
		}
	},

	methods: {
		/*********打开编辑框，初始化**********/
		open(data) {
			this._editState = !!data;
			this.$refs.form.clear();
			if (data) {
				this.$refs.form.set(data);
			}
			//填充form表单
			this.$refs.dialog.open({
				title: data ? '编辑计量单位' : '创建计量单位'
			});
		},

		/*******创建、编辑提交处理方法********/
		editHandle (stop, next){
			stop();
			this.$refs.form.submit({
				url: this._editState?'/dic/unit/edit':'/dic/unit/add',
				rule: {
					unit: '请输入单位名称'
				},
				dataFormatter: data => {
					return data;
				},
				success: (data, res) => {
					next();
					this.$message({
						message: '提交成功',  // 提示内容,
						type: 'success'
					});
					this.$emit('resolve');
				}
			});
		}
	}
}
</script>

<style lang="stylus" scoped>
</style>